import React, { createContext, useState, useContext } from "react";
import ErrorModal from "./servererror";


const ErrorContext = createContext();

export const useError = () => useContext(ErrorContext);

export const ErrorProvider = ({ children }) => {
  const [errorMessage, setErrorMessage] = useState(null);

  const showError = (message) => setErrorMessage(message);
  const clearError = () => setErrorMessage(null);

  return (
    <ErrorContext.Provider value={{ showError }}>
      {children}
      <ErrorModal message={errorMessage} onClose={clearError} />
    </ErrorContext.Provider>
  );
};
